module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticStyle: {
      "padding-top": "15px",
      "padding-bottom": "14px",
      "border-bottom": "1px solid rgb(209, 219, 229)"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("所属系统:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.filterForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.filterForm, "sysCode", $$v)
      },
      expression: "filterForm.sysCode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "all"
    }
  }), _vm._v(" "), _vm._l((_vm.sysAppList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })], 2), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("所属项目:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择项目",
      "suffix-icon": "el-icon-date"
    },
    on: {
      "focus": _vm.showProjectTree
    },
    model: {
      value: (_vm.projectNames),
      callback: function($$v) {
        _vm.projectNames = $$v
      },
      expression: "projectNames"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "项目归属"
    },
    model: {
      value: (_vm.projectTreeDialogVisible),
      callback: function($$v) {
        _vm.projectTreeDialogVisible = $$v
      },
      expression: "projectTreeDialogVisible"
    }
  }, [_c('div', {}, [_c('el-input', {
    attrs: {
      "placeholder": "输入关键字进行过滤"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "projectTree",
    staticClass: "filter-tree",
    attrs: {
      "data": _vm.projectTree,
      "show-checkbox": "",
      "node-key": "id",
      "default-checked-keys": _vm.projectTreeDefaultChecked,
      "filter-node-method": _vm.filterNode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.projectTreeOnCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.projectTreeOnSubmit
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("点类型:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.filterForm.dataType),
      callback: function($$v) {
        _vm.$set(_vm.filterForm, "dataType", $$v)
      },
      expression: "filterForm.dataType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "all"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "AI",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "DI",
      "value": "1"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("点搜索:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "输入点名称/编号"
    },
    model: {
      value: (_vm.filterForm.search_word),
      callback: function($$v) {
        _vm.$set(_vm.filterForm, "search_word", $$v)
      },
      expression: "filterForm.search_word"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        _vm.queryBtn()
      }
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "0px",
      "padding-bottom": "2px",
      "margin": "5px 0px"
    },
    attrs: {
      "span": 24
    }
  }, [(_vm.permissionNodeList.BA_add.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增点")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.BA_del.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.handleBatchDelete
    }
  }, [_vm._v("删除点")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.BA_import.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.handleBatchImport
    }
  }, [_vm._v("批量导入")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.BA_export.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("数据导出")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量导入项目"
    },
    on: {
      "close": _vm.cancelUpload
    },
    model: {
      value: (_vm.batchImportDialogVisible),
      callback: function($$v) {
        _vm.batchImportDialogVisible = $$v
      },
      expression: "batchImportDialogVisible"
    }
  }, [_c('el-upload', {
    ref: "batchImportUpload",
    attrs: {
      "limit": 1,
      "on-exceed": _vm.handleUploadExceed,
      "action": _vm.uploadUrl,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "before-upload": _vm.handleBeforeUpload,
      "headers": _vm.uploadHeader,
      "auto-upload": false
    }
  }, [_c('span', [_vm._v("选取文件:    ")]), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "inline",
      "padding-left": "350px",
      "color": "#b0b1b3",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.downloadTemplate($event)
      }
    }
  }, [_vm._v("模版下载")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "margin-top": "55px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("温馨提示:只能上传excel文件，且不超过20MB")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchImportOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list_data,
      "size": "mini",
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "所属项目",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sn",
      "label": "点编号",
      "width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dataType",
      "label": "点类型",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "valueTypeName",
      "label": "数据类型",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "点名称",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysCodeName",
      "label": "所属系统",
      "min-width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.alarmIgnoreAble == '0' && _vm.permissionNodeList.BA_shield.hasEntitle == 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleBlock(scope.$index, scope.row)
            }
          }
        }, [_vm._v("屏蔽")]) : _vm._e(), _vm._v(" "), (scope.row.alarmIgnoreAble == '1' && _vm.permissionNodeList.BA_shield.hasEntitle == 1) ? _c('el-button', {
          staticStyle: {
            "color": "#b0b1b3"
          },
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleUnBlock(scope.$index, scope.row)
            }
          }
        }, [_vm._v("已屏蔽")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.BA_conf.hasEntitle == 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleSetting(scope.$index, scope.row)
            }
          }
        }, [_vm._v("配置")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.BA_show.hasEntitle == 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleShowSetting(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看配置")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.BA_edit.hasEntitle == 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 15,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增BA点位",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelAddSubmit
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.saveFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "点名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点类型",
      "prop": "dataType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.dataType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "dataType", $$v)
      },
      expression: "addForm.dataType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("AI")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("DI")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "sn",
      "label": "点编号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.sn),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sn", $$v)
      },
      expression: "addForm.sn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "点地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型",
      "prop": "valueType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.valueType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "valueType", $$v)
      },
      expression: "addForm.valueType"
    }
  }, _vm._l((_vm.valueTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属项目",
      "prop": "projectId"
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.projectId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "projectId", $$v)
      },
      expression: "addForm.projectId"
    }
  }, _vm._l((_vm.projectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属系统",
      "prop": "sysCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sysCode", $$v)
      },
      expression: "addForm.sysCode"
    }
  }, _vm._l((_vm.sysAppList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelAddSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.saveFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "点名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点类型",
      "prop": "dataType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.dataType),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "dataType", $$v)
      },
      expression: "editForm.dataType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("AI")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("DI")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "sn",
      "label": "点编号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.sn),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sn", $$v)
      },
      expression: "editForm.sn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "点地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", $$v)
      },
      expression: "editForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型",
      "prop": "valueType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.editForm.valueType),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "valueType", $$v)
      },
      expression: "editForm.valueType"
    }
  }, _vm._l((_vm.valueTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属项目",
      "prop": "projectId"
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.projectId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "projectId", $$v)
      },
      expression: "editForm.projectId"
    }
  }, _vm._l((_vm.projectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属系统",
      "prop": "sysCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sysCode", $$v)
      },
      expression: "editForm.sysCode"
    }
  }, _vm._l((_vm.sysAppList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false;
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.editSubmitButtonDisabled,
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "屏蔽",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelBlockSubmit
    },
    model: {
      value: (_vm.blockFormVisible),
      callback: function($$v) {
        _vm.blockFormVisible = $$v
      },
      expression: "blockFormVisible"
    }
  }, [_c('el-form', {
    ref: "blockForm",
    attrs: {
      "model": _vm.blockForm,
      "label-width": "120px",
      "rules": _vm.blockFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "点名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.blockForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点类型:",
      "prop": "dataType"
    }
  }, [(_vm.blockForm.dataType == 0) ? _c('span', [_vm._v("AI")]) : _c('span', [_vm._v("DI")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "屏蔽开始时间",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime"
    },
    model: {
      value: (_vm.blockForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.blockForm, "startTime", $$v)
      },
      expression: "blockForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "屏蔽结束时间",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime"
    },
    model: {
      value: (_vm.blockForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.blockForm, "endTime", $$v)
      },
      expression: "blockForm.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelBlockSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.blockSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.blockSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "配置",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelSettingSubmit
    },
    model: {
      value: (_vm.settingFormVisible),
      callback: function($$v) {
        _vm.settingFormVisible = $$v
      },
      expression: "settingFormVisible"
    }
  }, [_c('el-form', {
    ref: "settingForm",
    attrs: {
      "model": _vm.settingForm,
      "label-width": "120px",
      "rules": _vm.settingFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "点名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.settingForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点类型:",
      "prop": "dataType"
    }
  }, [(_vm.settingForm.dataType == 0) ? _c('span', [_vm._v("AI")]) : _c('span', [_vm._v("DI")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "告警:",
      "prop": "alarmType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settingForm.alarmType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmType", $$v)
      },
      expression: "settingForm.alarmType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("报警")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": -1
    }
  }, [_vm._v("预警")]), _vm._v(" "), (_vm.settingForm.dataType == '0') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("预警+报警")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.settingForm.dataType == '0') ? _c('el-form-item', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.unit),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "unit", $$v)
      },
      expression: "settingForm.unit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '0' && (_vm.settingForm.alarmType == '0' || _vm.settingForm.alarmType == '-1' || _vm.settingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "lowerThreshold", $$v)
      },
      expression: "settingForm.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "upperThreshold", $$v)
      },
      expression: "settingForm.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '0' && _vm.settingForm.alarmType == '1') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyLowerThreshold", $$v)
      },
      expression: "settingForm.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyUpperThreshold", $$v)
      },
      expression: "settingForm.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "状态说明",
      "prop": "explainModel"
    }
  }, [_c('span', [_vm._v("0:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.zeroExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "zeroExplain", $$v)
      },
      expression: "settingForm.zeroExplain"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("1:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.oneExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "oneExplain", $$v)
      },
      expression: "settingForm.oneExplain"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "报警状态",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.explainModel),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "explainModel", $$v)
      },
      expression: "settingForm.explainModel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "01",
      "value": "2"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "alarmTimeout",
      "label": "告警超时:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入1-3000的自然数"
    },
    model: {
      value: (_vm.settingForm.alarmTimeout),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmTimeout", $$v)
      },
      expression: "settingForm.alarmTimeout"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("分钟")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelSettingSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.settingSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.settingSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看配置",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelShowSettingSubmit
    },
    model: {
      value: (_vm.showSettingFormVisible),
      callback: function($$v) {
        _vm.showSettingFormVisible = $$v
      },
      expression: "showSettingFormVisible"
    }
  }, [_c('el-form', {
    ref: "settingForm",
    attrs: {
      "model": _vm.settingForm,
      "label-width": "120px",
      "rules": _vm.settingFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "点名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.settingForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点类型:",
      "prop": "dataType"
    }
  }, [(_vm.settingForm.dataType == 0) ? _c('span', [_vm._v("AI")]) : _c('span', [_vm._v("DI")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "告警:",
      "prop": "alarmType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.alarmType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmType", $$v)
      },
      expression: "settingForm.alarmType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("报警")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": -1
    }
  }, [_vm._v("预警")]), _vm._v(" "), (_vm.settingForm.dataType == '0') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("预警+报警")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.settingForm.dataType == '0') ? _c('el-form-item', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.unit),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "unit", $$v)
      },
      expression: "settingForm.unit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '0' && (_vm.settingForm.alarmType == '0' || _vm.settingForm.alarmType == '1' || _vm.settingForm.alarmType == '-1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "lowerThreshold", $$v)
      },
      expression: "settingForm.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "upperThreshold", $$v)
      },
      expression: "settingForm.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '0' && _vm.settingForm.alarmType == '1') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyLowerThreshold", $$v)
      },
      expression: "settingForm.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyUpperThreshold", $$v)
      },
      expression: "settingForm.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "状态说明",
      "prop": "explainModel"
    }
  }, [_c('span', [_vm._v("0:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.zeroExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "zeroExplain", $$v)
      },
      expression: "settingForm.zeroExplain"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("1:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.oneExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "oneExplain", $$v)
      },
      expression: "settingForm.oneExplain"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "报警状态",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.explainModel),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "explainModel", $$v)
      },
      expression: "settingForm.explainModel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "01",
      "value": "2"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "alarmTimeout",
      "label": "告警超时:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.alarmTimeout),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmTimeout", $$v)
      },
      expression: "settingForm.alarmTimeout"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("分钟")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelShowSettingSubmit($event)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2c7e68c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/assets_manage/ba_list.vue
// module id = 842
// module chunks = 1